import { render, staticRenderFns } from "./TedsLauncherIcon.vue?vue&type=template&id=58d1848c&"
import script from "./TedsLauncherIcon.vue?vue&type=script&lang=ts&"
export * from "./TedsLauncherIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TedsLauncherIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports